import { observable, computed, toJS } from 'mobx'
import Model from '../shared/model'

import validate from '../shared/decorators/model/validate'

@validate({

  listCurriculum: 'required|array|minLen:1',
  listDay: 'required|array|minLen:1',
  listEquipment: 'required|array|minLen:1',
  listGrade: 'required|array|minLen:1',
  listMaterial: 'required|array|minLen:1',
  listMethod: 'required|array|minLen:1',
  listQs: 'required|array|minLen:1',
  listRegion: 'required|array|minLen:1',
  listSchool: 'required|array|minLen:1',
  listSubject: 'required|array|minLen:1',

})
export default class Settings extends Model {

  @observable listCurriculum = []

  @observable listDay = []

  @observable listEquipment = []

  @observable listGrade = []

  @observable listMaterial = []

  @observable listMethod = []

  @observable listQs = []

  @observable listRegion = []

  @observable listSchool = []

  @observable listSubject = []

  constructor(...args) {
    super(...args)
    this.initValidate()

    this.lists = [
      // { new: 'Neuer Lehrplan', name: 'Lehrpläne', key: 'listCurriculum' },
      { new: 'Neuer Tag', name: 'Tage', key: 'listDay' },
      { new: 'Neue Ausstattung', name: 'Ausstattungen', key: 'listEquipment' },
      { new: 'Neue Jahrgangsstufe', name: 'Jahrgangsstufen', key: 'listGrade' },
      { new: 'Neues Material', name: 'Materialien', key: 'listMaterial' },
      { new: 'Neue Methode', name: 'Methoden', key: 'listMethod' },
      { new: 'Neue Maßnahme', name: 'Maßnahmen zur Qualitätssicherung', key: 'listQs' },
      { new: 'Neuer Landkreis', name: 'Landkreise', key: 'listRegion' },
      { new: 'Neue Schule', name: 'Schulen', key: 'listSchool' },
      { new: 'Neues Fach', name: 'Fächer', key: 'listSubject' },
    ]
  }

  parse(data) {
    return data
  }

  @computed get asJSON() {

    return {
      listCurriculum: this.listCurriculum,
      listDay: this.listDay,
      listEquipment: this.listEquipment,
      listGrade: this.listGrade,
      listMaterial: this.listMaterial,
      listMethod: this.listMethod,
      listQs: this.listQs,
      listRegion: this.listRegion,
      listSchool: this.listSchool,
      listSubject: this.listSubject,
    }

  }

  getJSON() {
    return this.asJSON
  }

  add(list, data) {
    const opts = {
      action: 'add',
      list
    }
    this.store.save(null, data, opts)
      .then(({ body }) => {
        const items = toJS(this[list])
        this[list] = [
          ...items,
          body
        ]
      })
  }

  remove(list, id) {
    const opts = {
      action: 'remove',
      list,
      id
    }
    this.store.destroy(id, opts)
      .then(() => {
        const items = toJS(this[list])
        const item = items.find((i) => i.id === id)
        const index = items.indexOf(item)
        this[list] = [
          ...items.slice(0, index),
          ...items.slice(index + 1)
        ]
      })
  }

}



// WEBPACK FOOTER //
// ./src/settings/model.js